import { StoryblokAsset } from "../../../interfaces/StoryblokAsset.interface";

export interface SbImageMetadata {
    width: number;
    height: number;
    aspectRatio: number;
}

export const getSbImageMetadata = (asset: StoryblokAsset): SbImageMetadata => {
    const STORYBLOK_DOMAIN: string = 'https://a.storyblok.com/';
    const path: string = asset.filename.replaceAll(STORYBLOK_DOMAIN, '');
    const [, , dimensions, ,] = path.split('/');
    const [width, height] = dimensions.split('x').map((dimension) => Number(dimension));
    const aspectRatio: number = width / height;
    return {
        width: width,
        height: height,
        aspectRatio
    }
}